import React, { useEffect, useMemo, useState } from 'react';
import { Icon } from '@iconify/react';
import { AppButton, AppModal } from '../ui';

function flattenOptions(groups = []) {
  return groups.flatMap((group) => (group.options ?? []).map((opt) => ({
    value: String(opt.value ?? opt.id),
    label: opt.label ?? opt.libelle ?? String(opt.id),
  })));
}

const ItiTypeSiteFonctionnalitesModal = ({
  open,
  typeSiteOption,
  fonctionnalitesGroups = [],
  saving = false,
  onClose,
  onSave,
}) => {
  const [draftIds, setDraftIds] = useState([]);

  const allOptions = useMemo(() => flattenOptions(fonctionnalitesGroups), [fonctionnalitesGroups]);

  useEffect(() => {
    if (open && typeSiteOption) {
      setDraftIds((typeSiteOption.fonctionnalite_ids ?? []).map(String));
    }
  }, [open, typeSiteOption]);

  if (!open || !typeSiteOption) {
    return null;
  }

  const toggleDraft = (id) => {
    const key = String(id);
    setDraftIds((prev) => (
      prev.includes(key) ? prev.filter((item) => item !== key) : [...prev, key]
    ));
  };

  const handleSave = () => {
    onSave?.(typeSiteOption.id, draftIds.map(Number));
  };

  return (
    <AppModal
      show
      className="iti-site-modal"
      size="lg"
      scrollable
      onClose={onClose}
      closeDisabled={saving}
      title={`Fonctionnalités liées — ${typeSiteOption.libelle}`}
      footerClassName="d-flex justify-content-between align-items-center"
      footer={(
        <>
          <div className="d-flex align-items-center gap-2">
            <AppButton
              size="sm"
              variant="outline-secondary"
              onClick={() => setDraftIds([])}
              disabled={saving || draftIds.length === 0}
            >
              Tout effacer
            </AppButton>
            {draftIds.length > 0 && (
              <span className="small text-secondary-light">
                {draftIds.length} sélectionnée{draftIds.length > 1 ? 's' : ''}
              </span>
            )}
          </div>
          <div className="d-flex gap-2">
            <AppButton variant="outline-secondary" onClick={onClose} disabled={saving}>Annuler</AppButton>
            <AppButton onClick={handleSave} loading={saving} loadingLabel="Enregistrement…">Enregistrer</AppButton>
          </div>
        </>
      )}
    >
            <p className="small text-muted mb-3">
              Ces fonctionnalités seront proposées et ajoutées automatiquement lorsqu&apos;un site reçoit ce type.
            </p>
            <div className="iti-fonctionnalites-picker" role="group" aria-label="Fonctionnalités liées au type de site">
              {allOptions.map((opt) => {
                const selected = draftIds.includes(opt.value);
                return (
                  <button
                    key={opt.value}
                    type="button"
                    className={[
                      'iti-fonctionnalite-tag-btn',
                      selected ? 'is-selected' : '',
                    ].filter(Boolean).join(' ')}
                    onClick={() => toggleDraft(opt.value)}
                    aria-pressed={selected}
                    disabled={saving}
                  >
                    {selected && <Icon icon="mdi:check" width={14} className="iti-fonctionnalite-tag-btn__check" />}
                    <span>{opt.label}</span>
                  </button>
                );
              })}
            </div>
    </AppModal>
  );
};

export default ItiTypeSiteFonctionnalitesModal;
